/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Button,
  Modal,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import HideIf from 'loracoms/HideIf';
import IntlMsg from 'lorautils/intl/IntlMsg';


const defaultProps = {
  show: false,
};

const propTypes = {
  plan: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  onHide: React.PropTypes.func.isRequired,
  show: React.PropTypes.bool,
};

class AppOOQModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      show: props.show,
    };
    this.intlMsg = new IntlMsg(props.intl, 'application');
  }

  componentWillReceiveProps(nextProps) {
    const { plan, show } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  render() {
    const { pushState, onHide } = this.props;
    const { plan, show } = this.state;
    let tier = 3;

    if (plan.status === 'success') {
      tier = plan.data.tier;
    }

    const body = (
      <div>
        <HideIf if="profile:cube">
          <div>
            <ShowIf if={tier < 3}>
              <div>
                <p>
                  {this.intlMsg.msg('addapp.error.outofquota.undercomm')}
                </p>
                <Button
                  bsStyle="aisz-primary"
                  onClick={() => pushState('/billing/plans')}
                >
                  {this.intlMsg.msg('addapp.upgrade.btn')}
                  {' '}
                  <i className="fa fa-arrow-circle-o-right" />
                </Button>
              </div>
            </ShowIf>
            <ShowIf if={tier === 3}>
              <div>
                <p>
                  {this.intlMsg.msg('addapp.error.outofquota.comm')}
                </p>
                <a href="mailto:support@aisenz.com">support@aisenz.com</a>
              </div>
            </ShowIf>
          </div>
        </HideIf>
        <ShowIf if="profile:cube">
          <div>
            <p>
              {this.intlMsg.msg('addapp.error.outofquota.cube')}
            </p>
            <a href="mailto:support@aisenz.com">support@aisenz.com</a>
          </div>
        </ShowIf>
      </div>
    );

    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            {this.intlMsg.msg('addapp.error.modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {body}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

}

AppOOQModal.defaultProps = defaultProps;
AppOOQModal.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AppOOQModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/AppOOQModal/index.jsx